import { Gift } from "lucide-react";
import { GiftSteps } from "@/components/GiftSteps";

export const ListHowTo = ({ onOpenList }) => (
  <section id="come-funziona-lista" data-testid="list-howto" className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-6 sm:py-10">
    <div className="rounded-3xl bg-[#FBF3EE] border border-[#F0DDD3] p-5 sm:p-8">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-5">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#C87D75]">La lista nascita</div>
          <h2 className="font-serif text-2xl sm:text-3xl text-[#2D2825] mt-1">Come funziona la lista</h2>
          <p className="text-sm text-[#5C534E] mt-1 max-w-xl">Tre passi semplici: tu scegli, chi ti vuole bene regala con lo sconto del 15%, e nessuno compra due volte lo stesso capo.</p>
        </div>
        <button data-testid="list-howto-open" onClick={onOpenList}
          className="self-start sm:self-auto inline-flex items-center gap-2 rounded-full bg-[#C87D75] hover:bg-[#b56c64] text-white px-5 min-h-[44px] text-sm transition-colors">
          <Gift size={15} /> Apri la mia lista
        </button>
      </div>
      <GiftSteps />
    </div>
  </section>
);
